var hexToRgb = function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgb(".concat(hexToInt(result, 1), ", ").concat(hexToInt(result, 2), ",").concat(hexToInt(result, 3), ")") : null;
};
var hexToInt = function hexToInt(arr, index) {
  return parseInt(arr[index], 16);
};
export var getContrastYIQ = function getContrastYIQ(hex) {
  var rgb = hexToRgb(hex);
  var modifyRgb = rgb ? rgb.substring(4, rgb.length - 1).replace(/ /g, '').split(',') : [];
  var yiq = modifyRgb !== null && modifyRgb !== void 0 && modifyRgb.length ? (Number(modifyRgb[0]) * 299 + Number(modifyRgb[1]) * 587 + Number(modifyRgb[2]) * 114) / 1000 : 0;
  return yiq >= 128 ? 'light' : 'dark';
};